import { API } from '../../api/API';
import { BUSINESS_ACCOUNTS_URL, BUSINESS_ACCNT_BILLS_URL, USER_ACCOUNT_URL,BUSINESS_ACCOUNT_TYPES_URL } from '../../config/config';
import _ from "lodash";
import { evenRound } from 'util/NumberUtils';

export const getAccounts = async () => {
    let response = await API.get(BUSINESS_ACCOUNTS_URL)
    return response.data.accounts;
}

export async function getAccountTypes () {
    let response = await API.get(BUSINESS_ACCOUNT_TYPES_URL)
    return response.data;
}

export const getAccountById = async (accountId) => {
    let resp = await API.get(BUSINESS_ACCOUNTS_URL + '/' + accountId);
    return resp.data;
}

export const getBillById = async (billId) => {
    let resp = await API.get(BUSINESS_ACCNT_BILLS_URL + '/' + billId);
    return resp.data;
}

export const getBills = async (page, size, keyword, fromBillDate, toBillDate) => {
    let response = await API.get(BUSINESS_ACCNT_BILLS_URL,{
        params: {
          size: size,
          page: page,
          keyword: keyword,
          fromBillDate: fromBillDate,
          toBillDate: toBillDate
        }
    });

    return response.data;
}

export const getAccountType = (id, accountTypes) => {
    let accountType = accountTypes.filter((accountTypeObj) => accountTypeObj.id === id) 
    if (_.isEmpty(accountType)){
        return null;
    }
    return accountType[0].accountTypeDisplayName;
}

export const getUsersByAccount = (accountId) => {
    return API.get(USER_ACCOUNT_URL + '/' + accountId);
}

export const registerBill = async (formData) => {
    let formClone = _.cloneDeep(formData);
    for (let bli of formClone.lineItems) {
        bli.lineItemAmount = Math.trunc(evenRound(parseFloat(bli.lineItemAmount) * 100));
    }
    let response = await API.post(BUSINESS_ACCNT_BILLS_URL, formClone);
    return response.data;

}

export const deleteBill = async (billId) => {

    let response = await API.delete(BUSINESS_ACCNT_BILLS_URL + '/' + billId);
    if (response.status === 200) {
        response.data = {
            'success': true,
            'message': 'Bill deleted successfully'
        };
    }
    return response.data;
}

export const updateBill = async (billId, billData) => {
    let formClone = _.cloneDeep(billData);
    for (let bli of formClone.lineItems) {
        bli.lineItemAmount = Math.trunc(evenRound(parseFloat(bli.lineItemAmount) * 100));
    }
    let response = await API.put(BUSINESS_ACCNT_BILLS_URL + '/' + billId, formClone)
    if (response.status === 200) {
        response.data = {
            'success': true,
            'message': 'Bill updated successfully'
        };
    }
    return response.data;
}